import React from "react";
import { Callout } from "@/components/ms";

/** handles error scenarios for TradesList */
export const TradeListError = ({
  isSearching,
  error,
  setIsError,
  trades,
  items,
}) => {
  if (error) {
    setIsError(true);
    return (
      <Callout tone="neg" className="mb-4">
        <b>We couldn't load these transactions.</b>{" "}
        {error?.message || String(error)}
      </Callout>
    );
  }

  if (
    (trades?.length === 0 && !isSearching) ||
    (items?.length === 0 && isSearching)
  ) {
    setIsError(true);
  }

  return null;
};
